/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Page_Promise_ChangeInputs */

const en_pricing_page_promise_change = /** @type {(inputs: Pricing_Page_Promise_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change your plan at any time`)
};

const pl_pricing_page_promise_change = /** @type {(inputs: Pricing_Page_Promise_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan zmienisz w każdej chwili`)
};

/**
* | output |
* | --- |
* | "Change your plan at any time" |
*
* @param {Pricing_Page_Promise_ChangeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const pricing_page_promise_change = /** @type {((inputs?: Pricing_Page_Promise_ChangeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Page_Promise_ChangeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_pricing_page_promise_change(inputs)
	return en_pricing_page_promise_change(inputs)
});